import React, { FC } from 'react';
import { SocketProvider } from 'common/context';
import { GoodPage } from 'app/pages';

interface IComponentProps {}

export const GoodPageWrapper: FC<IComponentProps> = () => {
  return (
    <SocketProvider>
      <div className="redesign relative px-11 h-full flex direction-column" style={{ minWidth: 1360 }}>
        <div className="mx-11 flex direction-column flex-1">
          <GoodPage />
        </div>
      </div>
    </SocketProvider>
  );
};
